import * as XLSX from "xlsx";
import { convertAppFieldsToDbProperties } from "../../utils/fieldConversion";
import { downloadBlob } from "../../utils/downloadFile";
import { serializeMetadataYaml } from "./metadataYaml";

export const useYMLDownload = () => {
  const getFile = (selectedRecord, recordId) => {
    const exportedFilename = `metadata_${recordId}.yml`;
    const blob = new Blob(
      [
        serializeMetadataYaml(
          convertAppFieldsToDbProperties(
            selectedRecord.currentMetadata,
            recordId,
          ),
        ),
      ],
      { type: "text/plain;charset=utf-8;" },
    );
    downloadBlob(blob, exportedFilename);
  };
  return getFile;
};

export const useExcelDownload = () => {
  const getFile = (recordId) => {
    const headers = ["Input File Name", "Output File Name", "Other Files"];
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([headers]);
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    downloadBlob(blob, `metadata_${recordId}.xlsx`);
  };
  return getFile;
};
